module.exports = __webpack_public_path__ + "static/news-app-cover-ba20d79c6b1ef70d04b4f762ea153583.png";